const E = {
  Default: 'Default',
  Save: 'Save',
  Selected: 'Selected',
  Close: 'Close',
  Columns: 'Columns',
  Available: 'Available',
};

const F = {
  Default: 'Par défaut',
  Save: 'Enregistrer',
  Selected: 'Sélectionné',
  Close: 'Annuler',
  Columns: 'Colonnes',
  Available: 'Disponible',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/editColumns.js